import styled from 'styled-components';

import { Button } from '@gympass/yoga';

export const SeeResult = styled(Button.Link)`
  display: table-cell;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
`;

export const CustomTh = styled.div`
  table tr th {
    text-transform: none;
    font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
    line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  }
`;
